import { AttachmentFileType } from '../AttachmentFileTypeEnum';
import { FlowchartNodeDto } from '../FlowchartNodeDto';
import { GuidelineActionDto } from '../GuidelineActionDto';
import { GuidelineLinkDto } from '../GuidelineLinkDto';
import { TimeSpanDto } from '../TimeSpanDto';
import { ReferenceWithNumber } from './reference-with-number.type';

export interface NodeDetailPopoverAttachment {
  id: string;
  title: string;
  fileType: AttachmentFileType;
  updatedAtTimestamp: string;
}

export type NodeDetailPopoverDescription = {
  recurrence?: number | null;
  recurrenceInterval?: TimeSpanDto;
  description: string;
};

/**
 * Data for the node detail popover.
 * @property nodeTitle - The title of the node.
 * @property description - The description of the node. If undefined, the description tab will not be shown.
 * @property attachments - The attachments of the node. If empty, the attachments tab will not be shown.
 * @property links - The links of the node. If empty, the links tab will not be shown.
 * @property medications - The medications of the node. If empty, the medications tab will not be shown.
 * @property selectedTab - The selected tab of the popover. By default, the first available tab will be selected.
 * @property note - The note of the node.
 * @property flowchartElement - The flowchart element of the node.
 * @property chapter - The chapter of the node.
 */
export type NodeDetailPopoverData = {
  nodeTitle?: string;
  description?: NodeDetailPopoverDescription;
  attachments?: NodeDetailPopoverAttachment[];
  localAttachments?: NodeDetailPopoverAttachment[];
  deletedOriginalAttachmentIds?: string[];
  links?: GuidelineLinkDto[];
  medications?: GuidelineActionDto[];
  selectedTab?: NodeDetailPopoverTab;
  references?: ReferenceWithNumber[];
  flowchartElement?: FlowchartNodeDto;
  isPublicPage?: boolean;
  isEditImportedMode?: boolean;
  isPreviewMode?: boolean;
  isUpdateReviewMode?: boolean;
};

export enum NodeDetailPopoverTab {
  DESCRIPTION = 'Description',
  ATTACHMENTS = 'Attachments',
  LINKS = 'Links',
  MEDICATIONS = 'Medications',
  REFERENCES = 'References',
}
